import { Modal, Form, Button } from "react-bootstrap";
import * as yup from "yup";
import { services } from "../config";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { useState } from "react";
import { confirmable, createConfirmation } from "react-confirm";
import Select from "react-select";
import { useEffect } from "react";
import { useBackendUrl } from "../utils/hooks";
import NumberCustomInput from "./utils/NumberCustomInput";

function CreateItemSize({ proceed, show }) {
  const backendUrl = useBackendUrl();
  const [isLoading, setIsLoading] = useState(false);

  const initialValues = {
    Size: "",
    Quantity: "",
  };
  const schema = yup.object().shape({
    Size: yup.string().required(),
    Quantity: yup.string().required(),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit: async (values) => {
      try {
        values.Size = `${values.Size} mm`;
        setIsLoading(true);
        let response = await fetch(
          `${backendUrl}/api/items/add-item-measurement`,
          {
            method: "POST",
            headers: {
              Accept: "Application/json",
              "Content-Type": "Application/json",
            },
            credentials: "include",
            body: JSON.stringify(values),
          }
        );

        if (!response.ok) {
          response = await response.json();
          toast.error(response.message);
        } else {
          const {
            data: { itemMeasurement },
          } = await response.json();
          proceed(itemMeasurement);
        }
      } catch (err) {
        console.log(err);
        toast.error("Unable to get banks");
      } finally {
        setIsLoading(false);
      }
    },
  });

  const canClose = () => {
    proceed();
  };

  return (
    <Modal
      show={show}
      onHide={() => canClose()}
      centered={true}
      animation={false}
      enforceFocus={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h1 className="h6">Create Item Measurement</h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form noValidate onSubmit={formik.handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Size (mm)</Form.Label>
            <Form.Control
              type="number"
              placeholder="Enter Size eg. 32"
              name="Size"
              value={formik.values.Size}
              onChange={formik.handleChange}
              isInvalid={formik.touched.Size && !!formik.errors.Size}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Quantity</Form.Label>
            <NumberCustomInput
              type="text"
              placeholder="Enter Quantity equivalent"
              name="Quantity"
              value={formik.values.Quantity}
              onValueChange={(value, name) => {
                formik.setFieldValue(name, value);
              }}
              isInvalid={formik.touched.Quantity && !!formik.errors.Quantity}
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.Quantity}
            </Form.Control.Feedback>
          </Form.Group>

          <Button
            disabled={isLoading}
            variant="primary"
            className="w-100 p-2"
            type="submit"
          >
            {isLoading ? "Please wait…" : "Save"}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default function ItemSizeDialog(props) {
  return createConfirmation(confirmable(CreateItemSize))({ ...props });
}
